import TemplateCollectionsAPI from '@/api/template-collection'

const templateCollection = {
  namespaced: true,
  state: {
    collections: [],
    collectionDetails: null,
    isLoading: false,
  },
  mutations: {
    setCollectionDetails(state, details) {
      state.collectionDetails = details
    },
    setCollections(state, collections) {
      state.collections = collections
    },
    addCollection(state, collection) {
      state.collections.push(collection)
    },
    deleteCollection(state, collectionId) {
      const index = state.collections.findIndex(c => c.id === collectionId)

      if (index !== -1) {
        state.collections.splice(index, 1)
      }
    },
    deleteTemplateFromCollection(state, { collectionId, templateId }) {
      const collection = state.collections.find(c => c.id === collectionId)

      if (collection) {
        const index = collection.templates.findIndex(t => t.id === templateId)

        if (index !== -1) {
          collection.templates.splice(index, 1)
        }
      }
    },
    setLoading(state, loading) {
      state.isLoading = loading
    },
  },
  actions: {
    async fetchCollectionDetails({ commit }, collectionId) {
      commit('setLoading', true)
      try {
        const details = await TemplateCollectionsAPI.getDetails(collectionId)
        commit('setCollectionDetails', details)
      } catch (error) {
        console.error(error)
      } finally {
        commit('setLoading', false)
      }
    },
    async addTemplates({ commit }, { collectionId, templateIds }) {
      commit('setLoading', true)
      try {
        const response = await TemplateCollectionsAPI.addTemplates(collectionId, { templateIds })
        commit('setCollectionDetails', response)
      } catch (error) {
        console.error(error)
      } finally {
        commit('setLoading', false)
      }
    },
    async deleteTemplate({ commit }, { collectionId, templateId }) {
      commit('setLoading', true)
      try {
        const response = await TemplateCollectionsAPI.deleteTemplate(collectionId, templateId)
        commit('setCollectionDetails', response)
      } catch (error) {
        console.error(error)
      } finally {
        commit('setLoading', false)
      }
    },
    async deleteTemplateFromCollection({ commit }, { collectionId, templateId }) {
      commit('setLoading', true)
      try {
        await TemplateCollectionsAPI.deleteTemplate(collectionId, templateId)
        commit('deleteTemplateFromCollection', { collectionId, templateId })
      } catch (error) {
        console.error(error)
      } finally {
        commit('setLoading', false)
      }
    },
  },
}

export default templateCollection
